/* eslint-disable @typescript-eslint/naming-convention */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
  aws_appsync_graphqlEndpoint:
    "https://w7vzyn5iybaelblmn3dw5nifwe.appsync-api.ap-southeast-1.amazonaws.com/graphql",
  aws_appsync_region: "ap-southeast-1",
  aws_appsync_authenticationType: "API_KEY",
  aws_appsync_apiKey: "da2-m55zrlmt7zahlmqmb4xvm7alfq",
};
export default awsmobile;
